import { InjectionToken, Type } from '@angular/core';

/**
 * The ArcGIS pin picker's dialog class (`DesignContextPickerDialogComponent`), provided by SharedModule.
 * A token rather than an import keeps `LocationPickerLauncherService` — and every ArcGIS-free spec that
 * reaches it — from pulling @arcgis/core into its bundle. Unprovided, the launcher opens the Google picker.
 */
export const DESIGN_CONTEXT_PICKER_DIALOG = new InjectionToken<Type<unknown>>('DESIGN_CONTEXT_PICKER_DIALOG');
